import * as ls from '@/services/localStorage';
import moment from 'moment';

export function submittedTicketTracker(db) {
    const ticketSubmit = ls.getKey('ticketSubmitDate');
    if (ticketSubmit === null) {
        ls.setKey('ticketSubmitCount', 0);
        return db;
    }
    const lastDisplay = moment(parseInt(ticketSubmit));

    if (!lastDisplay.isSame(moment(), 'day')) {
        ls.setKey('ticketSubmitCount', 0);
    }
    return db;
}
